// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";

export interface OrderReleaseNumberStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    text?: TypographyPresentationProps;
}

export const orderReleaseNumberStyles: OrderReleaseNumberStyles = {};

const styles = orderReleaseNumberStyles;

const OrderDetailsReleaseNumber = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties || !order.properties.releasenumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsReleaseNumber">
                {translate("Release #")}
            </Typography>
            <Typography
                {...styles.text}
                aria-labelledby="orderDetailsReleaseNumber"
                data-test-selector="orderDetailsReleaseNumber"
            >
                {order.properties.releasenumber}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsReleaseNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
